var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 47,
    viewBox: "0 0 42 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_1134)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.47715 0 10V32C0 37.5228 4.47715 42 10 42H14.9956L19.2329 46.2342C20.209 47.2096 21.791 47.2096 22.7671 46.2342L27.0044 42H32C37.5228 42 42 37.5228 42 32V10C42 4.47715 37.5228 0 32 0H10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 6H14C9.58172 6 6 9.58172 6 14V28C6 32.4183 9.58172 36 14 36H28C32.4183 36 36 32.4183 36 28V14C36 9.58172 32.4183 6 28 6Z",
    fill: "#29D697"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_203_1134",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 14,
    width: 15,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14H13V29H28V14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_203_1134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6102 26.7533L21.7284 20.8715L14.8566 13.9996H14.3195L14.2099 14.2783C13.9205 15.0137 13.7968 15.766 13.8523 16.4535C13.9156 17.2373 14.2133 17.9158 14.7134 18.4159L20.078 23.7805L20.7855 23.0729L25.7451 28.6186C26.2384 29.1119 27.0876 29.1412 27.6102 28.6186C28.1245 28.1043 28.1245 27.2676 27.6102 26.7533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5918 22.5388L13.3903 26.7403C12.8761 27.2545 12.8761 28.0912 13.3903 28.6054C13.8788 29.0939 14.7239 29.1371 15.2555 28.6054L19.457 24.4039L17.5918 22.5388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3633 16.497L24.9799 18.8803L24.3582 18.2585L26.7415 15.8752L26.1197 15.2535L23.7364 17.6368L23.1147 17.015L25.498 14.6317L24.8763 14.01L21.7676 17.1187C21.3873 17.499 21.1603 18.004 21.1281 18.5406C21.12 18.6766 21.0892 18.8103 21.0381 18.9375L23.0575 20.9569C23.1847 20.9058 23.3185 20.875 23.4544 20.8669C23.9911 20.8348 24.496 20.6077 24.8763 20.2274L27.985 17.1187L27.3633 16.497Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_1134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 47,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFood);
export default __webpack_public_path__ + "static/media/pin_food.42cd14bc20778c39b9ff07a326afc953.svg";
export { ForwardRef as ReactComponent };